/**工资更正单 */
import { $http, buildHeaders } from "./index";

//获取列表
export const taxdeclarecorrect_list = (params) => {
  return $http.get("/admin/TaxDeclareCorrect/index", {
    params,
  });
};

//获取详情
export const taxdeclarecorrect_detail = (id) => {
  return $http.get("/admin/TaxDeclareCorrect/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取税期月份
export const taxdeclarecorrect_taxmonth = (id) => {
  return $http.get(
    "/admin/TaxDeclareCorrect/taxMonth?tax_declare_correct_id=" + id,
  );
};

//获取员工列表
export const taxdeclarecorrect_employee = (params) => {
  return $http.get("/admin/TaxDeclareCorrectEmployee/index", {
    params,
  });
};

//根据扣缴义务人id获取人员列表
export const taxdeclarecorrect_withholdingagent_employee_list = (params) => {
  return $http.get("/admin/TaxDeclareCorrect/withholdingAgentEmployee", {
    params,
  });
};

//添加
export const taxdeclarecorrect_add = (data) => {
  return $http.post("/admin/TaxDeclareCorrect/add", data, {
    headers: buildHeaders(3),
  });
};

//修改
export const taxdeclarecorrect_edit = (data) => {
  return $http.post("/admin/TaxDeclareCorrect/edit", data, {
    headers: buildHeaders(3),
  });
};

//设置员工当月不申报
export const taxdeclarecorrect_setresignation = (data) => {
  return $http.post("/admin/TaxDeclareCorrectEmployee/setResignation", data, {
    headers: buildHeaders(3),
  });
};

//保存更正单工资表数据
export const taxdeclarecorrect_savepayroll = (data) => {
  return $http.post("/admin/TaxDeclareCorrectEmployee/savePayroll", data, {
    headers: buildHeaders(3),
  });
};

//申请更正
export const taxdeclarecorrect_apply = (data) => {
  return $http.post("/admin/TaxDeclareCorrect/apply", data, {
    headers: buildHeaders(3),
  });
};

//撤销申请更正
export const taxdeclarecorrect_cancelapply = (data) => {
  return $http.post("/admin/TaxDeclareCorrect/cancelApply", data, {
    headers: buildHeaders(3),
  });
};

//提交更正单工资表算税
export const taxdeclarecorrect_calctaxpayroll = (data) => {
  return $http.post("/admin/TaxDeclareCorrectEmployee/calcTaxPayroll", data, {
    headers: buildHeaders(3),
  });
};

//取消更正单工资表算税
export const taxdeclarecorrect_cancelcalctaxpayroll = (data) => {
  return $http.post(
    "/admin/TaxDeclareCorrectEmployee/cancelCalcTaxPayroll",
    data,
    {
      headers: buildHeaders(3),
    },
  );
};

//提交更正单员工算税
export const taxdeclarecorrect_calctaxemployee = (data) => {
  return $http.post("/admin/TaxDeclareCorrectEmployee/calcTaxEmployee", data, {
    headers: buildHeaders(3),
  });
};

//取消更正单员工算税
export const taxdeclarecorrect_cancelcalctaxemployee = (data) => {
  return $http.post(
    "/admin/TaxDeclareCorrectEmployee/cancelCalcTaxEmployee",
    data,
    {
      headers: buildHeaders(3),
    },
  );
};

//提交更正单税期算税
export const taxdeclarecorrect_calctaxmonth = (data) => {
  return $http.post("/admin/TaxDeclareCorrect/calcTaxMonth", data, {
    headers: buildHeaders(3),
  });
};

//取消更正单税期算税
export const taxdeclarecorrect_cancelcalctaxmonth = (data) => {
  return $http.post("/admin/TaxDeclareCorrect/cancelCalcTaxMonth", data, {
    headers: buildHeaders(3),
  });
};
